import gql from "graphql-tag"

export const CREATE_OR_UPDATE_EXTERNAL_PRICE_CONFIG = gql`
  mutation createOrUpdateExternalPriceConfig(
    $id: ID!
    $baseUrl: String!
    $authUrl: String!
    $clientId: String!
    $clientSecret: String!
  ) {
    createOrUpdateExternalPriceConfig(
      id: $id
      externalPriceConfig: {
        baseUrl: $baseUrl
        authUrl: $authUrl
        clientId: $clientId
        clientSecret: $clientSecret
      }
    ) {
      id
    }
  }
`
